import {
  Button,
  Flex,
  Heading,
  Link,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
} from "@chakra-ui/react";
import { type ChainFullId, ChainFullIds } from "@umami/chains";
import { useDynamicModalContext } from "@umami/components";
import {
  useBuyTezUrl,
  useCurrentAccount,
  useGetNetworkChain,
  useGetNetworkSymbol,
} from "@umami/state";
import capitalize from "lodash/capitalize";

import { ExternalLinkIcon, WalletIcon } from "../../../assets/icons";
import { useColor } from "../../../styles/useColor";
import { ModalCloseButton } from "../../CloseButton";

import { getTokenDisplayName } from "@/utils/tokenUtils";

export const InsufficientFunds = ({ chainId }: { chainId?: ChainFullId }) => {
  const color = useColor();
  const currentAccount = useCurrentAccount();
  const buyTezUrl = useBuyTezUrl(currentAccount!.address.pkh);
  const getNetworkSymbol = useGetNetworkSymbol();

  const { onClose } = useDynamicModalContext();

  const getNetworkChain = useGetNetworkChain();
  const tokenDisplayName = getTokenDisplayName(getNetworkSymbol(chainId ?? ChainFullIds.TEZOS));

  const insufficientFundsMessage = chainId
    ? `${getNetworkSymbol(chainId)} on your ${capitalize(getNetworkChain(chainId))} account.`
    : "funds on your account.";

  const buyButtonText = `Buy ${tokenDisplayName}`;

  return (
    <ModalContent>
      <ModalHeader marginBottom="12px">
        <Flex alignItems="center" justifyContent="center" flexDirection="column" gap="18px">
          <WalletIcon width="24px" color={color("400")} />
          <Heading size="xl">Insufficient Funds</Heading>
        </Flex>
        <ModalCloseButton />
      </ModalHeader>
      <ModalBody>
        <Text color={color("700")} fontWeight="400" textAlign="center" size="md">
          Oops, looks like you don't have enough {insufficientFundsMessage}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button
          as={Link}
          width="full"
          href={buyTezUrl}
          isExternal
          leftIcon={<ExternalLinkIcon />}
          onClick={onClose}
          variant="primary"
        >
          {buyButtonText}
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
